/* eslint-disable prefer-destructuring */
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { navigate, withPrefix } from 'gatsby';
import NativeSelect from '@material-ui/core/NativeSelect';

import { generateNavItems } from './list';

export default function DropdownNav({ navItems, useLink, isPathActive, ...props }, { language }) {
  function onChange(e) {
    if (useLink) {
      navigate(e.target.value);
      return;
    }

    window.location.href = `/${language.locale}/${e.target.value}`.replace(/\/+/g, '/');
  }

  const items = generateNavItems(navItems);

  let link;
  items.forEach(option => {
    const path = useLink ? withPrefix(option.link) : option.link;
    const isActive = option.matchRegex ? option.matchRegex.test(path) : isPathActive(path);
    if (isActive) {
      link = option.link;
    }

    if (option.subPages) {
      option.subPages.forEach(subPage => {
        if (isPathActive(subPage.link)) {
          link = option.link;
        }
      });
    }
  });

  return (
    <Select {...props} value={link} onChange={onChange}>
      {items.map(option => (
        <option key={option.link} value={option.link}>
          {option.title}
        </option>
      ))}
    </Select>
  );
}

DropdownNav.propTypes = {
  navItems: PropTypes.array.isRequired,
  isPathActive: PropTypes.func.isRequired,
  useLink: PropTypes.bool,
};

DropdownNav.defaultProps = {
  useLink: false,
};

DropdownNav.contextTypes = {
  language: PropTypes.object,
};

const Select = styled(NativeSelect)`
  && {
    border: 1px solid #ccc;
    border-radius: 3px;
    padding: 0px 6px;
  }

  &&:before,
  &&:after {
    display: none;
  }
`;
